import dayjs from 'dayjs';

export function isIsoDate(date: string | dayjs.Dayjs) {
  const dayjsVersion = dayjs(date);
  return (
    dayjs.isDayjs(date) ||
    (dayjsVersion.isValid() && dayjsVersion.toISOString() === date)
  );
}
